module.exports = __webpack_public_path__ + "media/images/coin@3x-232813989a2e515eded20a7cd7d9dc2d.png";